import { render, staticRenderFns } from "./CheckBoxesGroup.vue?vue&type=template&id=dd315d7c&scoped=true"
import script from "./CheckBoxesGroup.vue?vue&type=script&lang=js"
export * from "./CheckBoxesGroup.vue?vue&type=script&lang=js"
import style0 from "./CheckBoxesGroup.vue?vue&type=style&index=0&id=dd315d7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd315d7c",
  null
  
)

export default component.exports